import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ExistenceCountResponse, HistoryExistenceAllWarehousesResponse, HistoryInventoryAllWarehousesResponse, WarehouseMissingDaysResponse } from 'src/app/models/inventory.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-history-inventory',
  templateUrl: './history-inventory.component.html',
  styleUrls: ['./history-inventory.component.scss']
})
export class HistoryInventoryComponent implements OnInit {
  filterWarehouse = new InputAutocompleteModel("", false, false, "", "fa-xmark", "", "", null, []);
  timeout = null;
  warehouses: WarehouseResponse[] = [];
  existences: HistoryExistenceAllWarehousesResponse[] = [];
  missingProducts: number = 0;
  //missingWarehouses: WarehouseMissingDaysResponse[] = [];
  loading = true;
  missingWarehouses: { [key: number]: number } = {};
  warehouseDefault: WarehouseResponse = new WarehouseResponse();
  created = null;

  filterByDate = false;
  selectedDate = new Date().toLocaleDateString('en-CA');
  filteredRecords: any[] = [];

  constructor(
    private toastService: ToastrService,
    private warehouseService: WarehouseService,
    private inventoryService: InventoryService
  ) {
    this.warehouseDefault.id = -1;
    this.warehouseDefault.nit = "--";
    this.warehouseDefault.code = "";
    this.warehouseDefault.name = "TODAS LAS BODEGAS";
  }

  ngOnInit(): void {
    this.getWarehousesByFilter(true);
    this.getActualInventory();
  }

  getActualInventory() {
    this.inventoryService.getActualInventory().subscribe({
      next: (response: ResponseObject) => {
        this.created = response.data.created;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getHistoryInventoryRandom() {
    if (this.filterWarehouse.data) {
      if (this.filterWarehouse.data.id == -1) {
        this.inventoryService.getHistoryInventoryRandom().subscribe({
          next: (response: ResponseObject) => {
            var res = response.data as HistoryInventoryAllWarehousesResponse;
            this.loading = false;
            this.existences = res.existences;
            this.missingProducts = res.missing;
            //this.missingWarehouses = res.list;
            res.list.forEach((missingWarehouse) => {
              this.missingWarehouses[missingWarehouse.warehouse.id] = missingWarehouse.missingDays;
            });
            this.filteredRecords = this.existences;
          },
          error: (error: HttpErrorResponse) => {
            this.loading = false;
            this.toastService.error(error.error.message);
          }
        })
      } else {
        this.inventoryService.getHistoryInventoryRandomByWarehouse(this.filterWarehouse.data.id).subscribe({
          next: (response: ResponseObject) => {
            var res = response.data as ExistenceCountResponse[];
            //this.missingWarehouses = res.list;
            this.existences = [];
            this.missingProducts = 0;
            var count = 0;
            res.forEach((existence) => {
              var temp = new HistoryExistenceAllWarehousesResponse();
              temp.comment = existence.comment;
              temp.date = existence.counted;
              temp.product = existence.product;
              temp.physicalStock = existence.physicalStock;
              temp.systemStock = existence.systemStock;
              temp.surplus = temp.physicalStock > temp.systemStock;
              temp.difference = Math.abs(temp.systemStock - temp.physicalStock);
              temp.user = existence.user;
              if (!temp.user) {
                count++;
              }
              this.existences.push(temp);
            });
            this.missingProducts = count;
            this.filteredRecords = this.existences;
            this.onFilter();
          },
          error: (error: HttpErrorResponse) => {
            this.loading = false;
            this.toastService.error(error.error.message);
          }
        })
      }
    }
  }

  selectWarehouse(warehouse: WarehouseResponse) {
    this.filterWarehouse.value = warehouse.name;
    this.filterWarehouse.verified = true;
    this.filterWarehouse.data = warehouse;
    this.filterWarehouse.class = "fa-circle-check";
    this.getHistoryInventoryRandom();
  }

  searchWarehouse() {
    clearTimeout(this.timeout);
    this.filterWarehouse.class = "typing";
    this.timeout = setTimeout(() => {
      this.getWarehousesByFilter();
    }, 300);
  }

  getWarehousesByFilter(firstCall = false) {
    this.filterWarehouse.class = "loading";
    this.warehouseService.getWarehouseByClue(this.filterWarehouse.value).subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data as WarehouseResponse[];
        this.warehouses.unshift(this.warehouseDefault);
        if (firstCall) {
          this.filterWarehouse.class = "fa-list";
          this.filterWarehouse.data = this.warehouses[0];
          this.filterWarehouse.value = "TODAS LAS BODEGAS";
        }
        this.getHistoryInventoryRandom();
      },
      error: (error: HttpErrorResponse) => {
        this.filterWarehouse.class = "fa-xmark";
        this.toastService.error(error.error.message);
      }
    })
  }

  toggleDateFilter(): void {
    const today = new Date().toLocaleDateString('en-CA');
    this.filterByDate = !this.filterByDate;

    if (!this.filterByDate) {
      this.selectedDate = today;
      this.filteredRecords = [...this.existences];
    }

    this.onFilter();
  }

  onDateChange(date: string): void {
    this.selectedDate = date;

    if (!date) {
      this.filteredRecords = [...this.existences];
      return;
    }

    this.filteredRecords = this.existences.filter(item => {
      const recordDate = new Date(item.date);

      const year = recordDate.getFullYear();
      const month = String(recordDate.getMonth() + 1).padStart(2, '0');
      const day = String(recordDate.getDate()).padStart(2, '0');

      const formattedDate = `${year}-${month}-${day}`;

      return formattedDate === date;
    });
  }

  onFilter(): void {
    if (!this.filterByDate) {
      this.filteredRecords = [...this.existences];
      return;
    }

    this.filteredRecords = this.existences.filter(item => {
      const recordDate = new Date(item.date);

      const year = recordDate.getFullYear();
      const month = String(recordDate.getMonth() + 1).padStart(2, '0');
      const day = String(recordDate.getDate()).padStart(2, '0');

      const formattedDate = `${year}-${month}-${day}`;

      return formattedDate === this.selectedDate;
    });
  }

}
